import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem('token');

  const handleLogout = () => {
    localStorage.removeItem('token'); // Clear token
    navigate('/'); // Redirect to login
  };

  const handleLinkClick = () => {
    setMenuOpen(false); // Close the menu on link click
  };

  return (
    <nav className="navbar-container">
      <div className="navbar-header">
        <h1 className="navbar-logo">Home Lead IQ</h1>
        <button className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
      </div>
      <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        {isAuthenticated ? (
          <>
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/leads"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Leads
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/analytics"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Analytics
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/calendar"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Calendar
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/calls"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Calls
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/email"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Email
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/pipeline"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Pipeline
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/settings"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
                onClick={handleLinkClick}
              >
                Settings
              </NavLink>
            </li>
            <li>
              <button onClick={handleLogout} className="logout-button">
                Logout
              </button>
            </li>
          </>
        ) : (
          <>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/login"
                className={({ isActive }) => (isActive ? 'nav-link active-link' : 'nav-link')}
              >
                Login
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;